import { useState } from 'react';
import { Modal, Button, ButtonProps } from '@warp-ds/react';

interface ExitWithConfirmationProps {
    confirmModal?: { title: string; confirm: string; abort: string };
    onExitFlow: Required<Pick<ButtonProps, 'children' | 'onClick'>> &
        Omit<ButtonProps, 'children' | 'onClick'>;
}

const ExitWithConfirmation = ({ onExitFlow, confirmModal }: ExitWithConfirmationProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const closeModal = () => setIsOpen(false);

    const { onClick, ...rest } = onExitFlow;

    const onExitFlowClick = (
        e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, globalThis.MouseEvent>,
    ) => {
        if (confirmModal) {
            setIsOpen(true);
        } else {
            onExitFlow.onClick(e);
        }
    };

    return (
        <div>
            {confirmModal && (
                <Modal
                    open={isOpen}
                    title={confirmModal.title}
                    right
                    onDismiss={closeModal}
                    footer={
                        <div className="grid grid-cols-2 gap-16 justify-stretch w-full sm:w-auto">
                            <Button secondary onClick={closeModal} className="tjt-min-button-width">
                                {confirmModal.abort}
                            </Button>
                            <Button
                                secondary
                                onClick={onExitFlow?.onClick}
                                className="tjt-min-button-width"
                            >
                                {confirmModal.confirm}
                            </Button>
                        </div>
                    }
                >
                    <div />
                </Modal>
            )}
            <Button quiet onClick={(e) => onExitFlowClick(e)} {...rest} />
        </div>
    );
};

export default ExitWithConfirmation;
